import { Breadcrumb } from 'antd'
import styled from 'styled-components'

import { getSpacing } from '../../../style/styleMixins/offset'
import { defaultTextStyle } from '../../../style/styleMixins/text'

export const MainWrapp = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: ${getSpacing([5, 0, 1, 0])};
  gap: ${getSpacing(1)};

  @media ${(p) => p.theme.breakpoints.tablet} {
    ${defaultTextStyle(2)};
    flex-direction: column;
  }

  @media ${(p) => p.theme.breakpoints.mobile} {
    margin-top: ${getSpacing(3)};
  }
`

export const SWrapp = styled.div`
  display: flex;
  max-width: 1120px;
  width: 100%;
  margin: 0 auto;
`

export const SBreadcrumb = styled(Breadcrumb)`
  .ant-breadcrumb-separator {
    color: ${(p) => p.theme.colors.grey_600};
  }

  .ant-breadcrumb-link {
    color: ${(p) => p.theme.colors.grey_450};

    a {
      color: ${(p) => p.theme.colors.blue_500};
    }
  }
`
